const ROUTES = {
  UNAUTHORISED: "/unauthorised",
  LOGIN: "/login",
  ADMIN_LOGIN: "/admin-login",
  FORGET_PASSWORD: "/forget-password",
  VERIFY: "/verify",
  RESET: "/reset",
  SIGN_UP: "/sign-up",
  PROFILE: "/my-profile",
  HOME: "/",
  CONTACT: "/contact",
  USER_LIST: "/users",
  ORDERS_LIST: "/order-admin",
  PLANS: "/pricing",
  UPLOAD_ARTWORK: "/upload-art",
  SHIPPING_ADDRESS: "/shipping-address",
  JOB_CONFIRM: "/job-confirmation",
  PAYMENT: "/payments/:invoice",
  JOB_REQUEST: "/jobs",
  DASHBOARD_ADMIN: "/dashboard-admin",
  ADMIN_ORDER_LIST: "/order-admin",
  ORDER_DETAIL: "/order-detail/:orderId",
  ARTWORK_LIST: "/artwork-list/:orderId",
  USER_ORDER_LIST: "/my-orders/:userId",
  PAYMENT_LIST: "/payment-list",
  VIEW_ORDER_STATUS: "/order-status/:orderId",
  UPDATE_ORDER_IMAGES: "/update-image/:orderId",
  UNAUTHORIZE_PAGE: "/unauthorize",
  TERMS_CONDITION: "/terms-condition",
  PRIVACY_POLICY: "/privacy",
  NOTIFICATION: "/notification",
  USER_ORDER_DETAILS: "/user-order-details/:orderId",
  SHEET_INFORMATION: "/sheet-information",
  JOB_CONFIRM_ORDERID: "/job-confirmation/:orderId",
  SHIPPING_ADDRESS_UNPAIDORDERS: "/shipping-address/:orderId",
  UNPAID_ORDERS_WITH_UPLOAD_ARTWORK: "/upload-art/:orderId",
  SETTINGS: "/settings",
  PAYMENT_ORDERID: "/payments/:userOrderId/:invoice",
  PAYMENT_PENDING_TOKEN: "/payment/:pendingToken/:invoice",
  PACKAGE_DETAIL: "/package-detail",
  SHEET_WEIGHT: "/sheet-weight",
};

export const DONT_SHOW_AFTER_LOGIN_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.FORGET_PASSWORD,
  ROUTES.VERIFY,
  ROUTES.RESET,
  ROUTES.SIGN_UP,
  ROUTES.ADMIN_LOGIN,
];

export const COMMON_ROUTES = [
  { path: ROUTES.HOME },
  { path: ROUTES.TERMS_CONDITION },
  { path: ROUTES.PRIVACY_POLICY },
];

export const USER_ROUTES = [
  { path: ROUTES.PROFILE },
  { path: ROUTES.CONTACT },
  { path: ROUTES.PLANS },
  { path: ROUTES.UPLOAD_ARTWORK },
  { path: ROUTES.SHIPPING_ADDRESS },
  { path: ROUTES.JOB_CONFIRM },
  { path: ROUTES.PAYMENT },
  { path: ROUTES.USER_ORDER_LIST },
  { path: ROUTES.VIEW_ORDER_STATUS },
  { path: ROUTES.USER_ORDER_DETAILS },
  { path: ROUTES.JOB_CONFIRM_ORDERID },
  { path: ROUTES.SHIPPING_ADDRESS_UNPAIDORDERS },
  { path: ROUTES.UNPAID_ORDERS_WITH_UPLOAD_ARTWORK },
  { path: ROUTES.PAYMENT_ORDERID },
  { path: ROUTES.PAYMENT_PENDING_TOKEN },
];

export const ADMIN_ROUTES = [
  { path: ROUTES.USER_LIST },
  { path: ROUTES.ORDERS_LIST },
  { path: ROUTES.DASHBOARD_ADMIN },
  { path: ROUTES.ADMIN_ORDER_LIST },
  { path: ROUTES.ORDER_DETAIL },
  { path: ROUTES.PAYMENT_LIST },
  { path: ROUTES.NOTIFICATION },
  { path: ROUTES.SHEET_INFORMATION },
  { path: ROUTES.SETTINGS },
  { path: ROUTES.PACKAGE_DETAIL },
  { path: ROUTES.SHEET_WEIGHT },
];
export const ARTIST_ROUTES = [
  { path: ROUTES.JOB_REQUEST },
  { path: ROUTES.ARTWORK_LIST },
  { path: ROUTES.NOTIFICATION },
  { path: ROUTES.USER_LIST },
];

export default ROUTES;
